import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { FcmService } from './shared';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  message;

  constructor( private fcmService: FcmService, private title: Title ) {
    title.setTitle('Field Service');
  }

  ngOnInit() {
    // this.fcmService.getPermission();

    // this.fcmService.receiveMessage();

    // this.message = this.fcmService.currentMessage;
  }
}
